import { useState } from "react";
import PropTypes from "prop-types";
import { Select } from "antd";
import Chart from "@/components/specific/Chart";
import LP from "@/assets/images/lp.png";
import PDP from "@/assets/images/pdp.png";
import APC from "@/assets/images/apc.png";
import NNPP from "@/assets/images/nnpp.png";

const CandidateReport = ({ data }) => {
  const [activeParty, setActiveParty] = useState("PDP");

  // Sample data for each party - in a real app, this would come from props or an API
  const partyData = {
    PDP: data,
    APC: data.map((item) => ({ ...item, value: item.value * 0.8 })),
    LP: data.map((item) => ({ ...item, value: item.value * 0.6 })),
    NNPP: data.map((item) => ({ ...item, value: item.value * 0.4 })),
  };

  const handlePartyClick = (party) => {
    setActiveParty(party);
  };

  return (
    <div>
      <div className="flex justify-between items-center mb-6">
        <h2 className="text-bold-x font-bold">Candidate Report</h2>
        <Select defaultValue="2023" />
      </div>

      <Chart
        data={partyData[activeParty]}
        type="Income"
        height={300}
        minWidth={300}
      />

      <div className="bg-secondary flex items-center gap-6 mt-6 p-2 rounded-lg">
        <div
          className={`flex items-center gap-2 px-4 py-2 rounded-lg cursor-pointer ${
            activeParty === "PDP" ? "bg-primary" : ""
          }`}
          onClick={() => handlePartyClick("PDP")}>
          <img src={PDP} alt="PDP" className="h-3 w-3" />
          <span
            className={`font-medium ${
              activeParty === "PDP" ? "text-white" : ""
            }`}>
            PDP
          </span>
        </div>
        <div
          className={`flex items-center gap-2 cursor-pointer ${
            activeParty === "APC" ? "bg-primary px-4 py-2 rounded-lg" : ""
          }`}
          onClick={() => handlePartyClick("APC")}>
          <img src={APC} alt="APC" className="h-3 w-3" />
          <span
            className={`font-medium ${
              activeParty === "APC" ? "text-white" : ""
            }`}>
            APC
          </span>
        </div>
        <div className="h-6 w-px bg-gray-300" /> {/* Vertical divider */}
        <div
          className={`flex items-center gap-2 cursor-pointer ${
            activeParty === "LP" ? "bg-primary px-4 py-2 rounded-lg" : ""
          }`}
          onClick={() => handlePartyClick("LP")}>
          <img src={LP} alt="LP" className="h-3 w-3" />
          <span
            className={`font-medium ${
              activeParty === "LP" ? "text-white" : ""
            }`}>
            LP
          </span>
        </div>
        <div
          className={`flex items-center gap-2 cursor-pointer ${
            activeParty === "NNPP" ? "bg-primary px-4 py-2 rounded-lg" : ""
          }`}
          onClick={() => handlePartyClick("NNPP")}>
          <img src={NNPP} alt="NNPP" className="h-3 w-3" />
          <span
            className={`font-medium ${
              activeParty === "NNPP" ? "text-white" : ""
            }`}>
            NNPP
          </span>
        </div>
      </div>
    </div>
  );
};

CandidateReport.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      time: PropTypes.string,
      value: PropTypes.number,
    })
  ),
};

export default CandidateReport;
